export class DynamicTableDefinition {
    dynamicTableId: number;
    field: string;
    caption: string;
    keyField: boolean;
    userEdit: boolean;
    listId: number;
    dataType: string;
    dataFormat: string;
    nameCellTemplate: string;
    defaultValueConvert: string;

    rowFormatOn: boolean;
    columnFormat: boolean;
    backgroundColour: string;
    fontBold: boolean;
    fontSize: string;
    textAlignment: string;
}

export class ManualInputTitle {
    dynamicTableId: number;
    dynamicTableName: string;
    dynamicTableGroup: string;
    pageTitle: string;
    enableDelete: boolean;
}

export class ManualInputDynamicTable {
    dynamicTableId: number;
    dynamicTableGroup1: string;
    dynamicTableGroup2: string;
    dynamicTableGroup3: string;
    dynamicTableGroup4: string;
    dynamicTableGroup5: string;
    dynamicTableGroup6: string;
    dynamicTableGroup7: string;
    dynamicTableGroup8: string;
    dynamicTableGroup9: string;
    dynamicTableGroup10: string;
    dynamicTableGroup11: string;
    dynamicTableGroup12: string;
    dynamicTableGroup13: string;
    dynamicTableGroup14: string;
    dynamicTableGroup15: string;
    dynamicTableGroup16: string;
    dynamicTableGroup17: string;
    dynamicTableGroup18: string;
    dynamicTableGroup19: string;
    dynamicTableGroup20: string;
    dynamicTableGroup21: string;
    dynamicTableGroup22: string;
    dynamicTableGroup23: string;
    dynamicTableGroup24: string;
    dynamicTableGroup25: string;
    dynamicTableGroup26: string;
    dynamicTableGroup27: string;
    dynamicTableGroup28: string;
    dynamicTableGroup29: string;
    dynamicTableGroup30: string;

    dynamicTableMeasure1: any;
    dynamicTableMeasure2: any;
    dynamicTableMeasure3: any;
    dynamicTableMeasure4: any;
    dynamicTableMeasure5: any;
    dynamicTableMeasure6: any;
    dynamicTableMeasure7: any;
    dynamicTableMeasure8: any;
    dynamicTableMeasure9: any;
    dynamicTableMeasure10: any;
    dynamicTableMeasure11: any;
    dynamicTableMeasure12: any;
    dynamicTableMeasure13: any;
    dynamicTableMeasure14: any;
    dynamicTableMeasure15: any;
    dynamicTableMeasure16: any; 
    dynamicTableMeasure17: any; 
    dynamicTableMeasure18: any; 
    dynamicTableMeasure19: any; 
    dynamicTableMeasure20: any;
    dynamicTableMeasure21: any;
    dynamicTableMeasure22: any;
    dynamicTableMeasure23: any;
    dynamicTableMeasure24: any;
    dynamicTableMeasure25: any;
    dynamicTableMeasure26: any;
    dynamicTableMeasure27: any;
    dynamicTableMeasure28: any;
    dynamicTableMeasure29: any;
    dynamicTableMeasure30: any;

    id: number;

    dynamicTableDateGroup1: Date | number | string;  
    dynamicTableDateGroup2: Date | number | string;
    dynamicTableDateGroup3: Date | number | string;
    dynamicTableDateGroup4: Date | number | string;
    dynamicTableDateGroup5: Date | number | string;
    dynamicTableDateGroup6: Date | number | string; 
    modfy: boolean = false;
    enableReadOnly: boolean = true;
    enableDelete: boolean = false;
}

export class ManualInputDynamicTablePrams {
    dynamicTableId: number;
    dynamicTableGroup1: string;
    dynamicTableGroup2: string;
    dynamicTableGroup3: string;
    dynamicTableGroup4: string;
    dynamicTableGroup5: string;
    dynamicTableGroup6: string;
    dynamicTableGroup7: string;
    dynamicTableGroup8: string;
    dynamicTableGroup9: string;
    dynamicTableGroup10: string;
    dynamicTableGroup11: string;
    dynamicTableGroup12: string;
    dynamicTableGroup13: string;
    dynamicTableGroup14: string;
    dynamicTableGroup15: string; 
    dynamicTableGroup16: string;
    dynamicTableGroup17: string;
    dynamicTableGroup18: string;
    dynamicTableGroup19: string;
    dynamicTableGroup20: string;
    dynamicTableGroup21: string;
    dynamicTableGroup22: string;
    dynamicTableGroup23: string;
    dynamicTableGroup24: string;
    dynamicTableGroup25: string;
    dynamicTableGroup26: string;
    dynamicTableGroup27: string;
    dynamicTableGroup28: string;
    dynamicTableGroup29: string;
    dynamicTableGroup30: string;

    dynamicTableMeasure1: string;
    dynamicTableMeasure2: string;
    dynamicTableMeasure3: string;
    dynamicTableMeasure4: string;
    dynamicTableMeasure5: string;
    dynamicTableMeasure6: string;
    dynamicTableMeasure7: string;
    dynamicTableMeasure8: string;
    dynamicTableMeasure9: string;
    dynamicTableMeasure10: string;
    dynamicTableMeasure11: string;
    dynamicTableMeasure12: string;
    dynamicTableMeasure13: string;
    dynamicTableMeasure14: string;
    dynamicTableMeasure15: string; 
    dynamicTableMeasure16: string; 
    dynamicTableMeasure17: string; 
    dynamicTableMeasure18: string; 
    dynamicTableMeasure19: string; 
    dynamicTableMeasure20: string;
    dynamicTableMeasure21: string;
    dynamicTableMeasure22: string;
    dynamicTableMeasure23: string;
    dynamicTableMeasure24: string;
    dynamicTableMeasure25: string;
    dynamicTableMeasure26: string;
    dynamicTableMeasure27: string;
    dynamicTableMeasure28: string;
    dynamicTableMeasure29: string;
    dynamicTableMeasure30: string; 

    dynamicTableDateGroup1: string;  
    dynamicTableDateGroup2: string;
    dynamicTableDateGroup3: string;
    dynamicTableDateGroup4: string;
    dynamicTableDateGroup5: string;
    dynamicTableDateGroup6: string; 
}

export class ManualInputUpdateDto {
    fields: DynamicTableDefinition[];
    values: ManualInputDynamicTable[];
    dynamicPageTitle:ManualInputTitle[];
    dynamicTableRow:DynamicTableRowDefinition[];
}

export class ListDatasource {
    listId: number;
    values: string[];
}

export class CoreListElement {
    listElementId: number;
    listId: number;
    listElement: string;
}

export class DynamicExcelParam {
    totalDataCount: number;
    headerCount: number;
    headerData: DynamicTableDefinition[];
    fileName: string;
    validationStarting: number;
    DynamicTableId: number;
    uniqueId: string; 
}

export class ErrorList {
    errorID: number;
    errorType: number;
    errorMessage: string;
    data: object;
}
 
export class ManualIds {
    dynamicTableId: number;
    Ids: MIds;

}

export class MIds {
    Id: number[];
}

export class DynamicTableRowDefinition {
    field: string;
    fieldName: string;
    fromValue: string;
    toValue: string;
    fromOperation: string;
    toOperation: string;
    userEdit: boolean;
    formatOn?: boolean;
    backgroundColour: string;
    fontBold?: boolean;
    rowHeight?: string;
    fontSize?: string; 
    enableDelete: boolean;
    textAlignment?: string;
}
